import { render, staticRenderFns } from "./BA.vue?vue&type=template&id=adf75d4c&"
import script from "./BA.vue?vue&type=script&lang=js&"
export * from "./BA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports